<button class="kz-kaza--options-order"
        [attr.data-order-asc]="order === requestOrder.DESC"
        (click)="toggleOrder()"
        [disabled]="disabled">
  <kz-icons name="chrono"></kz-icons>
  <kz-icons name="arrowdown"></kz-icons>
</button>
